import "./FileUploadComponent.scss";
import {useDropzone} from "react-dropzone";
import {ImageConfig} from "@/constants";

interface FileUploadComponentProps {
    onUpload: (files: any) => void;
    fileTypes?: string[];
    isMultiple?: boolean;
}

const FileUploadComponent = ({
                                 onUpload,
                                 fileTypes = ["image/*", "application/vnd.ms-excel", "text/csv"],
                                 isMultiple = true
                             }: FileUploadComponentProps) => {

    const {getRootProps, getInputProps} = useDropzone({
        accept: fileTypes.reduce((acc, type) => ({...acc, [type]: []}), {}),
        maxSize: 10 * 1024 * 1024, // 10MB limit
        multiple: isMultiple,
        onDrop: (acceptedFiles) => {
            const updatedFiles = acceptedFiles.map((file) => ({
                file,
                preview: URL.createObjectURL(file),
                progress: 0,
            }));
            onUpload(updatedFiles);
        },
    });

    return (
        <div>
            <div
                {...getRootProps()}
                className="cursor-pointer p-12 flex justify-center bg-[var(--input-background)] border border-dashed border-[var(--file-uploader-border)] rounded-xl dark:bg-neutral-800 dark:border-neutral-600"
            >
                <input {...getInputProps()} />
                <div className="text-center">
                    <ImageConfig.FileUploadIcon className="mx-auto"/>
                    <div className="mt-4 flex flex-wrap justify-center">
                        <span className="pe-1 font-normal dark:text-neutral-200 text-md text-secondary">
                            Drop <span className="text-primary"> png, jpg, csv, xlsx</span> files here
                        </span>
                    </div>
                    <p className="mt-1 text-sm dark:text-neutral-400 text-[var(--secondary-foreground)]">
                        Maximum size: 10MB. {isMultiple ? "Multiple files allowed" : "Single file only"}.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FileUploadComponent;
